<section>
  <app-form-header [menuDefinition]="menuDefinition" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="astral-stack-l">
      <section class="astral-content-width astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [span]="2" [control]="form.controls['importIdentifier']"></astral-input>
          <astral-date-picker [control]="form.controls['recievedAt']"></astral-date-picker>
          <astral-date-picker [control]="form.controls['importedAt']"></astral-date-picker>
        </astral-layout-group>
      </section>
      <div>
        <h4>{{ 'CONSUMPTION.IMPORT.METER_READINGS' | translate }}</h4>
        <app-list-view
          [columnDefinition]="readingsColumns"
          [itemsSource]="dataContext.meterReadings"
          [preferencesKey]="'consumption.import-meter-readings'"
        ></app-list-view>
      </div>
    </form>
  }
</section>
